<div class="pagination" *transloco="let t; read: 'app.pagination'">
  <button
    class="pagination__nav pagination__nav--previous"
    [disabled]="currentPage() <= 1"
    (click)="handlePageChange(currentPage() - 1)"
  >
    <app-svg-icon
      class="pagination__nav-icon pagination__nav-icon--previous"
      [icon]="'assets/images/pagination/arrow.svg'"
      [blank]="true"
    />
    <span class="pagination__nav-label">{{ t("previous") }}</span>
  </button>
  @for (page of leftPages(); track page; let i = $index) {
    <app-pagination-button
      class="pagination__number"
      [class.pagination__number--collapse]="i >= 2"
      [page]="page"
      [selected]="page === currentPage()"
      (pageChange)="handlePageChange(page)"
    />
  }
  @if (showDots()) {
    <span class="pagination__dots">...</span>
  }
  @for (page of rightPages(); track page; let i = $index) {
    <app-pagination-button
      class="pagination__number"
      [class.pagination__number--collapse]="i < rightPages().length - 2"
      [page]="page"
      [selected]="page === currentPage()"
      (pageChange)="handlePageChange(page)"
    />
  }
  <button
    class="pagination__nav pagination__nav--next"
    [disabled]="currentPage() >= totalPages()"
    (click)="handlePageChange(currentPage() + 1)"
  >
    <span class="pagination__nav-label">{{ t("next") }}</span>
    <app-svg-icon
      class="pagination__nav-icon"
      [icon]="'assets/images/pagination/arrow.svg'"
      [blank]="true"
    />
  </button>
</div>
